module.exports = __webpack_public_path__ + "static/media/cloud-sun.61792004.svg";